import { Component, Input, ViewEncapsulation, Inject, OnInit, HostListener, Output, EventEmitter, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { OvsComponent, Selectable, Core, QueryParamService } from '../../shared/core/ovs.core';
import { ResortDetail, ResortInventory, BookingDetail } from '../../models/presentation.model';
import { ResortInventoryGroup } from '../../models/browser.model';
import { ResortComponent } from '../../shared/resort.component';
import { NgbDateStruct, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ResortInventoryClientBase } from '../../services/resort-inventory.client';
import { MatDialogRef, MAT_DIALOG_DATA, MatSliderChange } from '@angular/material';
import * as moment from 'moment';
import { UpdateClientService } from '../../services/update-client.service';
import { ResortInsightsService } from '../../instrumentation/resort-insights.service';
import { ResortDetailsPageEvents, CheckoutPageEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

import { Room, ResortRoomsByNight } from './Room.model';

//Modal Gallery https://ks89.github.io/angular-modal-gallery-2018-v6.github.io/gettingStarted
import {
    AccessibilityConfig, Action, AdvancedLayout, ButtonEvent, ButtonsConfig, ButtonsStrategy, ButtonType, Description, DescriptionStrategy,
    DotsConfig, GalleryService, GridLayout, Image, ImageModalEvent, LineLayout, PlainGalleryConfig, PlainGalleryStrategy, PreviewConfig
} from '@ks89/angular-modal-gallery';
import { DateRange, Sleeps } from './room-mock.service';
import { OuterSubscriber } from 'rxjs/OuterSubscriber';
import { UnitType } from './unit-type.model';
import { RoomFilter } from './room-filter.model';
import { RoomFilterChangeInfo, DateChangeInfo } from './room-filter-change-info.model';
import { RoomFilterChangeTypes } from './room-filter-change-types.enum';
import { ImageService } from '../../services/image.service';
import { ModalSearchFilterComponent } from '../../shared/modal-search-filter/modal-search-filter.component';
import { SearchEvents, SearchResultEvents } from '../../instrumentation/resort-instrumentation.module';

@Component({
    selector: 'room-availability-v2',
    templateUrl: './room-availability-v2.component.html',
    styleUrls: ['./room-availability-v2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomAvailabilityV2Component extends ResortComponent implements OnInit, AfterViewInit {

    private _inventoryClient: ResortInventoryClientBase;
    private _core: Core;
    private _currentRoomFilterMaxPrice = 0;
    public group: ResortInventoryGroup;
    public selectedDate: NgbDateStruct;
    public nights: Selectable<number>[] = [];
    public sleeps: Selectable<number>[] = [];
    public availability: ResortInventory[] = [];
    public filteredResults: ResortInventory[] = [];
    public exactResults: ResortInventory[] = [];
    public allNearResults: ResortInventory[] = [];
    public nearResults: ResortInventory[] = [];
    public allRoomDescriptionIds: number[] = [];
    public filteredRoomsByDescId = new Map<number, ResortRoomsByNight[]>();
    public roomsByIntervalId = new Map<number, Room>();
    public minPrice = 0;
    public maxPrice = 1;
    public selectedPrice = 0;
    public shouldSortByHighestCost = false;
    public shouldSortByLowestCost = false;
    public shouldSortByBestValue = true;
    public usingUnitTypeIdsToSort = false;
    public roomImages: Image[] = [];
    public noSearchResults = false;

    private _previousDate: Date = null;
    //private _filetUpdated: boolean = false;
    private resortId: string;
    public rooms: Room[] = [];
    public roomFilter: RoomFilter = new RoomFilter();
    public onlyRoomTypeSelected: UnitType;
    public totalSearchResults: number;
    public isSearching: boolean;
    public selectedInventory: ResortInventory[] = [];
    public cheapestInventory: ResortInventory;
    public filteredCount = 0;
    public filteredModalCount = 0;
    public filteredNightsModalFlag = false;
    public filteredRoomTypesModalFlag = false;
    public filteredPriceSliderModalFlag = false;
    //public filteredWithinDaysModalFlag: boolean = false;

    @Input()
    public resortDetail: ResortDetail;
    @Input()
    public showPricePerDay: boolean;
    @Input()
    public showRewardsPerDay: boolean;
    @Input()
    public isAgent: boolean;
    @Input()
    public isPreferred: boolean;
    @Output()
    public startBooking: EventEmitter<any> = new EventEmitter();
    @Output()
    public startBookingWithUpgrade: EventEmitter<any> = new EventEmitter();
    public unitTypes: UnitType[] = new Array<UnitType>();
    @Input() noImages: boolean;
    @ViewChild('searchFilterResultModal') searchFilterResultModal: ModalSearchFilterComponent;

    constructor(
        private updateClientService: UpdateClientService,
        inventoryClient: ResortInventoryClientBase,
        core: Core, private qryParamService: QueryParamService, private imageService: ImageService
    ) {
        super();
        this.initialize();
        this._core = core;
        this._inventoryClient = inventoryClient;
        this.resortId = this.qryParamService.resortDetailParams.resortId;
        const initialStartDate: Date = this.qryParamService.resortDetailParams.startDate;
        this.selectedDate = this.dateToNgbDate(initialStartDate);
    }

    public monthDateSelected: Date;

    protected initialize(): void {
        super.initialize();
    }

    public ngAfterViewInit(): void {

    }

    public onRoomFilterUpdated(eventData: any): void {
        let changeInfo: RoomFilterChangeInfo = <RoomFilterChangeInfo>eventData;
        switch (changeInfo.changeType) {
            case RoomFilterChangeTypes.DateChange:
                this.onSelectedDateChanged(this.dateToNgbDate((<DateChangeInfo>changeInfo).date));
                break;
            default:
                this.filterUpdated(null);
                break;
        }
    }

    public get onlyRoomImages(): Array<string> {
        if (this.onlyRoomTypeSelected) {
            var images = this.availability.where(a => a.unitTypeName == this.onlyRoomTypeSelected.name).select(r => r.unitTypeImageList);
            var imagesList = new Array<string>();
            images.toArray().forEach(i => {
                i.forEach(x => {
                    let url = this.imageService.getImageUrl(x);
                    if (!imagesList.contains(url)) imagesList.add(url);
                });
            });

            if (imagesList.length === 0) {
                imagesList.add(ImageService.DUMMY_IMAGE_URL);
            }
            return imagesList;
        }
        return [];
    }

    handleErr(e) {
        UserActivityLogger.logEvent(ResortDetailsPageEvents.ResortDetailFailure, this.mapAppInsightsCustomEvents(e.message, e.status), UserActivityLoggerOptions.AppInsightsOnly);
    }

    public onSelectedDateChanged(date: NgbDateStruct): void {
        try {
            this.selectedDate = date;
            const newDate = this.ngbDateToDate(date);
            this.isSearching = true;
            this.noSearchResults = false;
            var self = this;
            this._inventoryClient.Get(this.resortId, newDate, r => this.onGetInventoryCompleted(r), self.handleErr.bind(this));
        } catch (ex) {
            console.log(ex);
        }

    }

    private mapAppInsightsCustomEvents(errorMessage, httpErrorCode) {
        const mapData = new Map();
        mapData.set("memberid", this.application.configuration.Member.Id);
        mapData.set("ovcpartnerid", this.application.configuration.Partner.Id);
        mapData.set("ovcpartner", this.application.configuration.Partner.LongName);
        mapData.set("memberclass", this.application.configuration.MemberClass);
        mapData.set("errormessage", errorMessage ? errorMessage : "Search error unknown");
        mapData.set("httperrorcode", httpErrorCode);
        mapData.set("product", "Resort");
        mapData.set("origination", "ICE");
        let jsonObject = {};
        mapData.forEach((value, key) => {
            jsonObject[key] = value;
        });
        return jsonObject;
    }


    public selectedDateChanged(date) {
        this.selectedDate = this.dateToNgbDate(date);
        this.monthDateSelected = date;
        this.onSelectedDateChanged(this.selectedDate);
    }

    private onGetInventoryCompleted(inventory: ResortInventory[]): void {
        try {
            this.noSearchResults = false;
            if (inventory.length === 0) {
                this.noSearchResults = true;
                this.isSearching = false;
                return;
            }
            this.availability = inventory;
            this.roomFilter = new RoomFilter();
            this.unitTypes = new Array<UnitType>();
            this.nights = new Array<Selectable<number>>();
            this.totalSearchResults = inventory.length;

            if (this.showPricePerDay) {
                this.minPrice = inventory.min(i => i.discountPurchaseTypeId > 0 ? i.dailyDiscountedPrice : i.dailyPrice);
                this.maxPrice = inventory.max(i => i.discountPurchaseTypeId > 0 ? i.dailyDiscountedPrice : i.dailyPrice);
            }
            else {
                this.minPrice = inventory.min(i => i.discountPurchaseTypeId > 0 ? i.discountedPrice : i.price);
                this.maxPrice = inventory.max(i => i.discountPurchaseTypeId > 0 ? i.discountedPrice : i.price);
            }

            this.selectedPrice = this.maxPrice;

            let oldNights: Selectable<number>[] = this.nights.where(n => n.isSelected).toArray();
            let oldSleeps: Selectable<number>[] = this.sleeps.where(n => n.isSelected).toArray();

            this.nights = this.availability.select(a => a.nights).distinct().orderByDescending(b => b).select(a => new Selectable<number>(a)).toArray();

            this.sleeps = this.availability.select(a => a.maxOccupancy).distinct().select(a => new Selectable<number>(a)).toArray();

            if (oldNights.length > 0) {
                this.nights.forEach(v => {
                    v.isSelected = oldNights.contains(v, (l, r) => l.value == r.value);
                });
            }
            else {
                this.nights.forEach(n => { n.isSelected = true; });
            }

            this.sleeps.forEach(v => {
                v.isSelected = oldSleeps.contains(v, (l, r) => l.value === r.value);
            });

            this.availability.forEach(a => {
                if (this.unitTypes.where(u => u.name === a.unitTypeName || u.name === a.unitType).count() === 0) {
                    let unitType = new UnitType();
                    unitType.id = a.unitTypeId;
                    unitType.name = this.isPreferred ? a.unitTypeName : a.unitType;
                    unitType.adultOccupancy = a.adultOccupancy;
                    unitType.childOccupancy = a.childOccupancy;
                    unitType.description = a.unitTypeDescription;
                    unitType.unitTypeDescriptionId = a.unitTypeDescriptionId;
                    unitType.unitBeddingTypes = a.unitBeddingTypes;
                    unitType.isSelected = true;
                    this.unitTypes.add(unitType);
                }
            });

            this.roomFilter.unitTypes = this.unitTypes;
            this.roomFilter.nights = this.nights;
            this.roomFilter.minPrice = Math.ceil(this.minPrice);
            this.roomFilter.maxPrice = Math.ceil(this.maxPrice);
            this.filterUpdated(null);
            this.isSearching = false;

        } catch (ex) {
            UserActivityLogger.logEvent(ResortDetailsPageEvents.ResortDetailFailure, this.mapAppInsightsCustomEvents(ex.message, ex.code), UserActivityLoggerOptions.AppInsightsOnly);
        }

    }

    public formatNumber(value: number): string {
        let pipe: CurrencyPipe = new CurrencyPipe(Core.current.currentConfiguration.Locale);
        let result: string = pipe.transform(value, Core.current.currentConfiguration.CurrencyCode, "symbol", "1.0-0", Core.current.currentConfiguration.Locale);
        return result;
    }

    public resetFlag: boolean = false;

    public reset(): void {
        this.roomFilter.nights.forEach(n => n.isSelected = true);
        this.roomFilter.unitTypes.forEach(n => n.isSelected = true);
        this.selectedPrice = this.roomFilter.maxPrice;
        this.resetFlag = !this.resetFlag;
        this.filterUpdated(this.roomFilter);
        this.filteredModalCount = 0;
    }

    private sameDay(d1, d2) {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    public onNightsChanged(): void {
        ResortInsightsService.logEvent(ResortDetailsPageEvents.AvailabitlityModalResultsFilterApplied, { filter: "nights" });
        this.filterUpdated(null);
    }

    public onSleepsChanged(): void {
        ResortInsightsService.logEvent(ResortDetailsPageEvents.AvailabitlityModalResultsFilterApplied, { filter: "sleeps" });
        this.filterUpdated(null);
    }

    public filterUpdated(currentRoomFilter: RoomFilter) {
        let query: IQueryable<ResortInventory> = this.availability.asQueryable();
        if (currentRoomFilter === null) currentRoomFilter = this.roomFilter;
        let selectedNights: number[] = currentRoomFilter.nights.select(n => n.value).toArray();
        let selectedSleeps: number[] = this.sleeps.where(s => s.isSelected).select(n => n.value).toArray();
        //TODO: filter within days of search date
        //let selectedWithinDaysOfDate: number = currentRoomFilter.withinDaysOfSelectedDate;
        if (this.showPricePerDay) {
            query = query.where(i => {
                return (selectedNights.length === 0 || selectedNights.contains(i.nights)) &&
                    (selectedSleeps.length === 0 || selectedSleeps.contains(i.maxOccupancy)) &&
                    i.dailyDiscountedPrice <= this.selectedPrice;
            });
        } else {
            query = query.where(i => {
                return (selectedNights.length === 0 || selectedNights.contains(i.nights)) &&
                    (selectedSleeps.length === 0 || selectedSleeps.contains(i.maxOccupancy)) &&
                    i.discountedPrice <= this.selectedPrice;
            });
        }

        query = query.where(i => currentRoomFilter.unitTypes.select(r => r.name)
            .contains(this.isPreferred ? i.unitTypeName : i.unitType));

        query = query.where(
            i => (i.discountPurchaseTypeId > 0
                ? (this.showPricePerDay ? i.dailyDiscountedPrice : i.discountedPrice)
                : (this.showPricePerDay ? i.dailyPrice : i.price)) <=
                currentRoomFilter.maxPrice);

        //TODO: filter within days of search date
        //if (selectedWithinDaysOfDate !== null && selectedWithinDaysOfDate !== undefined && selectedWithinDaysOfDate > 0) {
        //    const maxDate = new Date();
        //    maxDate.setDate(this.selectedDate.getDate() + selectedWithinDaysOfDate);
        //    const minDate = new Date();
        //    minDate.setDate(this.selectedDate.getDate() - selectedWithinDaysOfDate);
        //    query = query.where(w => w.checkInDate <= maxDate && w.checkInDate >= minDate);
        //}

        this._currentRoomFilterMaxPrice = currentRoomFilter.maxPrice;
        query = query.orderByDescending(d => d.nights).orderBy(f => f.checkInDate);

        this.filteredResults = query.toArray();
        this.allNearResults = [];
        this.nearResults = [];
        this.exactResults = [];
        const date = this.ngbDateToDate(this.selectedDate);
        this.allNearResults = this.filteredResults
            .where(i => date <= i.checkInDate || date >= i.checkOutDate).toArray();

        let idx: number = 0;
        for (idx = this.allNearResults.length - 1; idx >= 0; idx--) {
            let resortItem: ResortInventory = this.allNearResults[idx];
            let isSameDay: any = this.sameDay(date, resortItem.checkInDate);
            if (isSameDay == true) {
                this.allNearResults.splice(idx, 1);
                this.exactResults.add(resortItem);
            }
        }

        this.rooms = [];
        this.rooms.addRange(this.mapToRooms(this.exactResults.orderByDescending(r => r.nights).toArray()));
        this.rooms.addRange(this.mapToRooms(this.allNearResults.orderByDescending(r => r.nights).toArray(), false));
        this.getGroupedRoomTypes(this.rooms);

        this.rooms.forEach(rm => {
            this.roomsByIntervalId.set(rm.inventory.intervalId, rm);
        });

        this.currentInventoryCount = 0;
        this.evaluateLoadMore();
        this.nearResults = [];
        this.showMoreAvailability();
    }

    public getGroupedRoomTypes(rooms: Room[]) {

        this.allRoomDescriptionIds = [];
        this.filteredRoomsByDescId = new Map<number, ResortRoomsByNight[]>();
        this.usingUnitTypeIdsToSort = false;

        if (rooms && rooms.length > 0) {
            rooms.sort((a, b) => (a.inventory.price < b.inventory.price ? -1 : 1));
            const checkRoomDescriptionIds = rooms.select(i => i.inventory.unitTypeDescriptionId).distinct().toArray();
            const checkRoomUnitTypeIds = rooms.select(i => i.inventory.unitTypeId).distinct().toArray();

            if (checkRoomDescriptionIds !== null && checkRoomDescriptionIds !== undefined) {
                this.allRoomDescriptionIds = checkRoomDescriptionIds;

                if ((this.allRoomDescriptionIds.count() === 0 || (this.allRoomDescriptionIds.count() === 1 && this.allRoomDescriptionIds[0] === 0))
                    && checkRoomUnitTypeIds.count() > 0) {
                    this.usingUnitTypeIdsToSort = true;
                    this.allRoomDescriptionIds = checkRoomUnitTypeIds;
                    this.allRoomDescriptionIds.forEach(r => {
                        const roomsMatchingThisDescriptionId =
                            rooms.where(i => i.inventory.unitTypeId === r).toArray();

                        const nightsAvailableForMatchedRooms =
                            roomsMatchingThisDescriptionId.select(i => i.inventory.nights).distinct().toArray()
                                .sort();

                        const roomsAndNightsObjects = new Array<ResortRoomsByNight>();
                        nightsAvailableForMatchedRooms.forEach(n => {

                            const resortRoomsByNight = new ResortRoomsByNight();

                            resortRoomsByNight.nights = n;
                            resortRoomsByNight.rooms =
                                roomsMatchingThisDescriptionId.where(i => i.inventory.nights === n).toArray();
                            roomsAndNightsObjects.add(resortRoomsByNight);
                        });

                        this.filteredRoomsByDescId.set(r, roomsAndNightsObjects);
                    });
                }
                else {

                    //sort by unit type description ids
                    this.allRoomDescriptionIds.forEach(r => {
                        const roomsMatchingThisDescriptionId =
                            rooms.where(i => i.inventory.unitTypeDescriptionId === r).toArray();
                        const nightsAvailableForMatchedRooms =
                            roomsMatchingThisDescriptionId.select(i => i.inventory.nights).distinct().toArray().sort();
                        const roomsAndNightsObjects = new Array<ResortRoomsByNight>();
                        nightsAvailableForMatchedRooms.forEach(n => {

                            const resortRoomsByNight = new ResortRoomsByNight();

                            resortRoomsByNight.nights = n;
                            resortRoomsByNight.rooms =
                                roomsMatchingThisDescriptionId.where(i => i.inventory.nights === n).toArray();
                            roomsAndNightsObjects.add(resortRoomsByNight);
                        });

                        this.filteredRoomsByDescId.set(r, roomsAndNightsObjects);
                    });
                }
            }
        }
    }

    public getKeys(map) {
        return Array.from(map.keys());
    }

    public getValues(key) {
        let returnItems = new Array<ResortRoomsByNight>();
        returnItems = this.filteredRoomsByDescId.get(key);
        return returnItems;
    }

    public getRoomByIntervalId(key) {
        let selectedRoom = new Room();
        selectedRoom = this.roomsByIntervalId.get(parseInt(key));
        return selectedRoom;
    }

    public getRoomByIntervalIdAsArray(key) {
        let selectedRoom = new Room();
        const selectedRoomArray = new Array<Room>();
        selectedRoom = this.roomsByIntervalId.get(parseInt(key));
        selectedRoomArray.add(selectedRoom);
        return selectedRoomArray;
    }

    public getCheapestInventory(key): ResortInventory {
        if (this.usingUnitTypeIdsToSort) {
            this.selectedInventory = this.availability.where(a => a.unitTypeId === key).toArray();
        } else {
            this.selectedInventory = this.availability.where(a => a.unitTypeDescriptionId === key).toArray();
        }

        let minDiscountedPrice = 0;
        if (this.showPricePerDay) {
            minDiscountedPrice = this.selectedInventory.min(i => i.hasDiscount ? i.dailyDiscountedPrice : i.dailyPrice);
            this.cheapestInventory = this.selectedInventory.first(i => i.hasDiscount
                ? i.dailyDiscountedPrice === minDiscountedPrice
                : i.dailyPrice === minDiscountedPrice);
        } else {
            minDiscountedPrice = this.selectedInventory.min(i => i.hasDiscount ? i.discountedPrice : i.price);
            this.cheapestInventory = this.selectedInventory.first(i => i.hasDiscount
                ? i.discountedPrice === minDiscountedPrice
                : i.price === minDiscountedPrice);
        }

        return this.cheapestInventory;
    }

    private evaluateLoadMore(): void {
        if (this.currentInventoryCount + this.intialMaxInventoryCount <= this.rooms.length) {
            this.currentInventoryCount = this.currentInventoryCount + this.intialMaxInventoryCount;
        }
        else {
            this.currentInventoryCount = this.rooms.length;
        }

        if ((this.rooms.length - this.currentInventoryCount) <= 2) {
            this.currentInventoryCount += this.rooms.length - this.currentInventoryCount;
        }
        this.hasMoreRooms = (this.rooms.length - this.currentInventoryCount) > 0;

    }

    private mapToRooms(results: ResortInventory[], isExact: boolean = true): Room[] {
        let returnObj: Room[] = [];
        results.forEach(r => {

            let roomitem = new Room();
            roomitem.id = r.id;
            roomitem.roomType = this.isPreferred ? r.unitTypeName : r.unitType;
            roomitem.memberRate = this.showPricePerDay ? r.dailyDiscountedPrice : r.discountedPrice;

            let dateRange = new DateRange();
            dateRange.dateStart = moment(r.checkInDate).format('dddd, MMMM Do YYYY');
            dateRange.dateEnd = moment(r.checkOutDate).format('dddd, MMMM Do YYYY');
            roomitem.dateRange = dateRange;
            roomitem.sleeps = new Sleeps();
            roomitem.sleeps.adult = r.adultOccupancy;
            roomitem.sleeps.children = r.childOccupancy;
            roomitem.stays = r.nights.toString();
            roomitem.staysLabel = "Nights";
            roomitem.available = isExact;
            roomitem.availableOnDate = this.ngbDateToDate(this.selectedDate);
            roomitem.marketRate = this.showPricePerDay ? r.dailyPrice : r.price;
            roomitem.memberRateLabel = r.discountLabel;
            roomitem.memberCurrency = r.rewardType;
            roomitem.showPricePerDay = this.showPricePerDay;
            roomitem.hasDiscount = r.hasDiscount;
            roomitem.discountLabel = r.discountLabel;
            roomitem.purchaseLabel = r.purchaseLabel;
            roomitem.reward = r.reward;
            roomitem.rewardLabel = r.rewardLabel;
            roomitem.rewardPercent = r.rewardPercent;
            roomitem.rewardActionLabel = r.rewardActionLabel;
            roomitem.showRewardsPerDay = this.showRewardsPerDay;
            roomitem.inventory = r;
            returnObj.add(roomitem);
        });

        return returnObj;
    }
    public book(inventory: any) {
        this.startBooking.emit(inventory);
    }

    public bookWithUpgrade(inventory: any) {
        this.startBookingWithUpgrade.emit(inventory);
    }

    public showMoreAvailability(): void {
        let displayedCount: number = this.nearResults.length + 10;
        let totalCount: number = this.allNearResults.length;
        if (displayedCount > totalCount)
            displayedCount = totalCount;

        this.nearResults = this.allNearResults.orderBy(d => d.checkInDate).take(displayedCount).toArray();
        this.updateClientService.EnsureLatestVersion(() => { });
    }

    onScroll($event) {
        if ($event.currentTarget) {
            var scrollPercent = Math.round(100 * $event.currentTarget.scrollTop / $event.currentTarget.scrollHeight);
            if (scrollPercent > 50) this.showMoreAvailability();
        }
    }

    // public close(): void {
    //   this._thisDialog.close();
    // }

    public checkInDateClick(): void {

    }
    public closeAvailabilityModal() {
        ResortInsightsService.logEvent(ResortDetailsPageEvents.AvailabitlityModalCloseButtonClicked);
    }
    // #endregion


    // Component Grid and List Configs - added 10/8/2018

    // Responsive
    public windowWidth: number;
    public mdScreen: boolean;
    public xsScreen: boolean;
    public mdScreenWindow: number = 993; // Viewport = iPad Tablet
    public xsScreenWindow: number = 767; // Viewport = x-Small Device

    public mdScreenSize(): void {
        if (this.windowWidth < this.mdScreenWindow) {
            this.mdScreen = true;
        } else {
            this.mdScreen = false;
            this.xsScreen = false;
        }
    }
    public xsScreenSize(): void {
        if (this.windowWidth < this.xsScreenWindow) {
            this.xsScreen = true;
            this.mdScreen = false;
        } else {
            this.xsScreen = false;
        }
    }
    public checkWindowSize(): void {
        this.windowWidth = window.innerWidth;
        this.xsScreenSize();
        this.mdScreenSize();
        console.log(
            // 'mdScreen: ' + this.mdScreen,
            // 'xsScreen: ' + this.xsScreen,
        );
    }

    // Toggle Grid to List layouts
    // Grid layout by default
    // List layout not available on small devices.

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.checkWindowSize();
    }

    // //Room Filter Show More

    private intialMaxInventoryCount: number = 8;
    public currentInventoryCount: number = 0;
    public hasMoreRooms: boolean = true;
    public loadMoreRooms(): void {
        this.evaluateLoadMore();
    }

    //Layout Orientation
    //Grid View = Default
    //List View toggled

    public _toggleLayout: boolean;

    // Available Flag

    // public isAvailable: Room;
    public available(room: Room): void {
        room.available;
    }


    // Filter Events
    public get imagesDisabled(): boolean {

        return false;
    }


    ngOnInit() {
        this.onSelectedDateChanged(this.selectedDate);
        this.monthDateSelected = this.ngbDateToDate(this.selectedDate);
    }

    //Image Gallery Configs
    customPlainGalleryRowConfig: PlainGalleryConfig = {
        strategy: PlainGalleryStrategy.CUSTOM,
        layout: new AdvancedLayout(-1, true),
    };


    customDescriptionHidden: Description = {
        strategy: DescriptionStrategy.ALWAYS_HIDDEN,
        customFullDescription: 'Custom description of the current visible image'
    };

    openImageModalRow(image: Image) {
        console.log('Opening modal gallery from custom plain gallery row, with image: ', image);
        const index: number = this.getCurrentIndexCustomLayout(image, this.roomImages);
        this.customPlainGalleryRowConfig = Object.assign({}, this.customPlainGalleryRowConfig,
            { layout: new AdvancedLayout(index, true) });
    }

    private getCurrentIndexCustomLayout(image: Image, roomImages: Image[]): number {
        return image ? roomImages.indexOf(image) : -1;
    }

    public onSearchFilterClick(): void {
        this.searchFilterResultModal.openSearchFilterModal();
    }

    public onBookClicked(intervalId): void {
        const bookingInventory = this.getRoomByIntervalId(intervalId).inventory;
        this.updateClientService.EnsureLatestVersion(() => {
            this.application.checkOut(this.resortDetail, bookingInventory, false);
        });
    }

    public get hasOnlineBooking(): boolean {
        return Core.current.currentConfiguration.HasOnlineBooking;
    }

    public get isUserAgent(): boolean {
        return Core.current.currentConfiguration.IsAgent;
    }


    userSearchFilterModalSelection(value: boolean) {
        UserActivityLogger.logEvent(SearchEvents.userSearchFilterModalSelection, { userchoice: value ? "Applied" : "Cancelled" }, UserActivityLoggerOptions.AppInsightsOnly);

        if (value) {
            this.searchFilterResultModal.closeSearchFilterModal();
            this.getAppliedFilterModalCount();
        }
        else {
            this.reset();
            this.filteredModalCount = 0;
            this.searchFilterResultModal.closeSearchFilterModal();
        }
    }

    public getAppliedFilterModalCount(): number {

        this.filteredModalCount = 0;
        this.filteredRoomTypesModalFlag = false;
        this.filteredNightsModalFlag = false;
        this.filteredPriceSliderModalFlag = false;

        this.roomFilter.unitTypes.forEach(r => {
            if (r.isSelected === false)
                this.filteredRoomTypesModalFlag = true;
        });

        if (this.filteredRoomTypesModalFlag) {
            this.filteredModalCount += 1;
        }


        this.roomFilter.nights.forEach(n => {
            if (n.isSelected === false) {
                this.filteredNightsModalFlag = true;
            }
        });

        if (this.filteredNightsModalFlag) {
            this.filteredModalCount += 1;
        }

        if (this._currentRoomFilterMaxPrice < this.roomFilter.maxPrice) {
            this.filteredPriceSliderModalFlag = true;
        }

        if (this.filteredPriceSliderModalFlag) {
            this.filteredModalCount += 1;
        }

        return this.filteredModalCount;

    }

    private ngbDateToDate(date: NgbDateStruct) {
        return new Date(date.year, date.month - 1, date.day);
    }

    private dateToNgbDate(date: Date) {
        return <NgbDateStruct>{ year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/room-availability-v2.component.ts